import styled from "styled-components";

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: ${({ theme }) => theme.space[4]};
  cursor: pointer;
  transition: border-color ${({ theme }) => theme.transitions.fast},
    box-shadow ${({ theme }) => theme.transitions.fast},
    transform ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: ${({ theme }) => theme.shadows.md};
    transform: translateY(-1px);
  }
`;

export const CardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space[3]};
  margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const CardInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CardName = styled.div`
  font-size: ${({ theme }) => theme.fonts.sm};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardDesc = styled.div`
  font-size: ${({ theme }) => theme.fonts.sm};
  color: ${({ theme }) => theme.colors.gray500};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: ${({ theme }) => theme.space[1]};
`;

export const CardDistance = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  margin-top: ${({ theme }) => theme.space[1]};
  font-size: ${({ theme }) => theme.fonts.xs};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.successBadge};
`;

export const RunningBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  margin-top: ${({ theme }) => theme.space[1]};
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.successBadge};
`;

export const RunningDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.successBadge};
  display: inline-block;
  animation: pulseDot 1.5s ease-in-out infinite;

  @keyframes pulseDot {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
`;

export const CardBadge = styled.span`
  background-color: ${({ theme }) => theme.colors.primaryBg};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radius.full};
  padding: ${({ theme }) => theme.space[1]} ${({ theme }) => theme.space[3]};
  font-size: ${({ theme }) => theme.fonts.xs};
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const CardTimes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[1]};
`;

export const TimeChip = styled.button`
  background-color: ${({ theme }) => theme.colors.successLighter};
  color: ${({ theme }) => theme.colors.success};
  border: none;
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: ${({ theme }) => theme.space[1]} ${({ theme }) => theme.space[2]};
  font-size: ${({ theme }) => theme.fonts.xs};
  font-weight: 700;
  cursor: pointer;
  transition: background-color ${({ theme }) => theme.transitions.fast},
    color ${({ theme }) => theme.transitions.fast};

  &:hover {
    background-color: ${({ theme }) => theme.colors.successLight};
    color: ${({ theme }) => theme.colors.white};
  }
`;
